export const sharedSectionTitleClassName = "text-[2.2rem] font-semibold leading-[1.08] tracking-[-0.03em] text-white sm:text-[2.8rem] md:text-[3.4rem]";

export const sharedSectionSubtitleClassName = "mt-4 max-w-2xl text-[1rem] leading-relaxed text-white/72 sm:text-[1.05rem]";
